import { Tip } from "@/components/ds";
import type { ProgramaNivel } from "@/types/capacitaciones-ia";

const NIVEL_LABEL: Record<ProgramaNivel, string> = {
  basico: "Básico",
  intermedio: "Intermedio",
  avanzado: "Avanzado",
};

/** Cuántas barras se prenden. El nivel lo eligió quien creó el programa y
 * gobierna la profundidad con la que la IA escribe el temario. */
const NIVEL_BARRAS: Record<ProgramaNivel, number> = {
  basico: 1,
  intermedio: 2,
  avanzado: 3,
};

/** Alturas crecientes, alineadas abajo — la escalera es lo que hace legible
 * el indicador de un vistazo, sin leer el número. */
const ALTURAS = [5, 8, 11];

/**
 * Nivel del programa como indicador de señal (1 a 3 barras) junto al nombre,
 * en reemplazo de la columna "Nivel" del listado.
 *
 * La INFORMACIÓN está en la cantidad de barras prendidas, no en el color: las
 * tres usan el mismo teal. Pintar "básico" de un color y "avanzado" de otro
 * sugeriría que un nivel es peor que otro, y no lo es — un programa básico
 * bien hecho no es una alerta.
 *
 * El nombre del nivel sigue disponible en el tooltip y en el `aria-label`: el
 * indicador es un resumen visual, no la única forma de acceder al dato.
 */
export function NivelPrograma({ nivel }: { nivel: ProgramaNivel }) {
  const prendidas = NIVEL_BARRAS[nivel];
  const etiqueta = `Nivel ${NIVEL_LABEL[nivel]}`;

  return (
    <Tip texto={etiqueta}>
      <span
        role="img"
        aria-label={etiqueta}
        className="flex h-[11px] shrink-0 items-end gap-[1.5px]"
      >
        {ALTURAS.map((alto, i) => (
          <span
            key={alto}
            className={i < prendidas ? "bg-primary" : "bg-border"}
            style={{ width: 3, height: alto, borderRadius: 1 }}
          />
        ))}
      </span>
    </Tip>
  );
}
